import { doc, onSnapshot } from 'firebase/firestore'
import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../context/AuthContext'
import { ChatContext } from '../context/ChatContext'
import { db } from '../firebase'

const Chats = () => {

    const array = [1, 12, 3, 5,]

    const [chats, setChats] = useState([])

    const { currentUser } = useContext(AuthContext)
    const { dispatch } = useContext(ChatContext)

    const handleSelect = (u) => {
        dispatch({ type: "CHANGE_USER", payload: u })
    }


    useEffect(() => {

        const getChats = () => {
            const unSub = onSnapshot(doc(db, "userChats", currentUser.uid), (doc) => {
                setChats(doc.data())
            })
            return () => {
                unSub()
            }
        }
        currentUser.uid && getChats()
    }, [currentUser.uid])

    console.log("chats", chats);

    return (
        <div className="chats">
            {
                Object.entries(chats)?.sort((a, b) => b[1].date - a[1].date).map((chat) => {
                    return (
                        <div className="userChat" onClick={() => handleSelect(chat[1].userInfo)} key={chat[0]}>
                            <img src={chat[1].userInfo.photoURL} alt="" />

                            <div className="userChatInfo">
                                <span>{chat[1].userInfo.displayName}</span>
                                <p>{chat[1].lastMessage?.text}</p>
                            </div>
                        </div>
                    )
                })
            }

        </div>
    )
}

export default Chats